const $ = jQuery.noConflict();

$(document).ready(function () {

  //Retrieve all Programs
  getProgramResults($);



  //The Search event will trigger once the user has stopped typing for 750 ms
  let timeout;
  $('[name="program-search"] #search').keyup(function () {

    clearTimeout(timeout);

    //if there is something typed
    if ($(this).val() !== '') {
      $('.searchbox .close-btn-container').show();
    } else {
      $('.searchbox .close-btn-container').hide();
    }

    timeout = setTimeout(function () {

      //retrive a new result
      getProgramResults($);

    }, 1000);
  });

  $('.searchbox .close-btn-container').click(function () {
    $('[name="program-search"] #search').val('');
    $(this).hide();
    getProgramResults($);
  });

  // remove submit functionality
  $('[name="program-search"]').submit(function (){
    return false;
  });



  // Degree Checkbox
  $('[name="degrees[]"]').change(function (){
    getProgramResults($);
  });

  // fields Checkbox
  $('[name="fields[]"]').change(function (){
    getProgramResults($);
  });

  // school Checkbox
  $('[name="schools[]"]').change(function (){
    getProgramResults($);
  });



  //clear all button
  $('a.clear-filter').click(function () {

    $('[name="program-search"] #search').val('');

    $('[name="degrees[]"]').each(function (){
      $(this).prop('checked', false);
    });

    $('[name="fields[]"]').each(function (){
      $(this).prop('checked', false);
    });

    $('[name="schools[]"]').each(function (){
      $(this).prop('checked', false);
    });

    getProgramResults($);
    //$('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
  });

  //mobile filters
  $('.filter-container h2').click(function (){

    let $container = $(this).parent('.filter-container');

    //if has class
    if ($container.hasClass('open')) {
      $container.removeClass('open');
    } else {
      $container.addClass('open');
    }
  });



  //load more button
  $('#academics-programs-and-majors .btn.load').click(function () {
    loadMore();
    return false;
  });

});




/*================================================================================
Definition: Load More Button
================================================================================*/
function loadMore () {

  let count = 0;

  $('#academics-programs-and-majors .btn.load').removeClass('more');
  $('.list-wrapper .row').each(function (){

    if (!$(this).hasClass('show')) {

      if (count < 50) {
        $(this).addClass('show');
      }

      if (count >= 50) {
        $('#academics-programs-and-majors .btn.load').addClass('more');
        return false;
      }

      count++;
    }
  });
}





/*================================================================================
Definition: Get New Results for the Program List
================================================================================*/
function getProgramResults ($) {

  let keyword = $('[name="program-search"] #search').val(),
    $programResults = $('.program-results'),
    degrees = '',
    fields = '',
    schools = '',
    total = 0;

  //get degrees
  $('input[name="degrees[]"]:checked').each(function () {
    degrees += encodeURIComponent($(this).val())+',';
  });
  degrees = degrees.substring(0, degrees.length - 1);

  //get fields
  $('input[name="fields[]"]:checked').each(function () {
    fields += encodeURIComponent($(this).val())+',';
  });
  fields = fields.substring(0, fields.length - 1);

  //get schools
  $('input[name="schools[]"]:checked').each(function () {
    schools += encodeURIComponent($(this).val())+',';
  });
  schools = schools.substring(0, schools.length - 1);

  //clear the list
  $programResults.html('');

  //show preloader
  showLoading($, true);

  //show clear filter
  if (!(degrees === '' && fields === '' && schools === '')) {
    $('.clear-filter').addClass('show');
  } else {
    $('.clear-filter').removeClass('show');
  }

  $.getJSON('/api/programs?s='+keyword+'&degrees='+degrees+'&fields='+fields+'&schools='+schools, function (result) {

    //hide the loading animation
    showLoading($, false);

    $programResults.html('<ul class="list-wrapper program-list" data-rows="50"></ul>');

    $.each(result, function (i, field) {
      buildProgramItem($, field, i);
      total++;
    });

    //update results
    if (total === 1) {
      $('.program-results-num').html(total + ' result');
    } else {
      $('.program-results-num').html(total + ' results');
    }

    //show the first 50
    $('#academics-programs-and-majors .btn.load').removeClass('more');
    $('.list-wrapper .row').each(function (i) {

      if (i < 50) {
        $(this).addClass('show');
      }

      if (i >= 50) {
        $('#academics-programs-and-majors .btn.load').addClass('more');
        return false;
      }
    });

  });
}


/*================================================================================
Definition: Show and Stop loading

status - true or false
================================================================================*/
function showLoading ($, status) {

  let $loading = $('.program-loading'),
    $btn = $('.results-container .load');

  if (status) {
    $loading.show();
    $btn.removeClass('more');
  } else {
    $loading.hide();
  }
}





/*================================================================================
Definition: Build the markup for each program items

program - the json item for programs
================================================================================*/
function buildProgramItem ($, program, key) {

  let $programResults = $('.program-results ul'),
    html = '',
    degreeList = program.Degree.split(','),
    urlList = program.URL.split(',');

  html += '<li class="row" data-row="'+key+'">';
  html += '  <div class="ucla campus">';
  html += '    <div class="col span_8_of_12">';
  html += '      <span class="major-title">'+program.Name+'</span>';
  html += '    </div>';
  html += '    <div class="col span_4_of_12 degree">';

  for (let i = 0; i < degreeList.length; i++) {
    html += '      <a href="'+urlList[i]+'">'+degreeList[i]+'</a>';
  }


  html += '    </div>';
  html += '    ';
  html += '  </div>';
  html += '</li>';

  $programResults.append(html);
}







/*const $ = jQuery.noConflict();

$(document).ready(function () {

  let resizeId;

  //elements
  let $search = $('#academics-programs-and-majors #search'),
    $button = $('#academics-programs-and-majors .btn.load'),
    $listWrapper = $('#academics-programs-and-majors .list-wrapper');

  //set the list load
  setListLoad($);

  //enable the search
  $search.hideseek();
  $search.on('_after', function () {

    setListLoad($);
    getListCount($, $(this).val());

    //if there is a keyword in searchfield
    if ($(this).val() !== '') {
      $('.countwrapper .clear-btn').addClass('show');
    } else {
      $('.countwrapper .clear-btn').removeClass('show');
    }
  });

  //load more click event
  $button.bind('click', function () {

    //update the data-rows
    let rowsUpdate = Number($listWrapper.attr('data-rows')) + 50;
    $listWrapper.attr('data-rows', rowsUpdate);

    //set the List Load
    setListLoad($);

    return false;
  });

  //On Submission
  $('form[name="program-search"]').submit(function () {
    return false;
  });

  $('.countwrapper .clear-btn').bind('click', function () {

    $search.val('');
    let e = $.Event('keyup', { keyCode: 8 });
    $search.trigger(e);

    $('.countwrapper .clear-btn').removeClass('show');

    return false;
  });

  //on window resize
  $(window).resize(function () {

    clearTimeout(resizeId);
    resizeId = setTimeout(function () { setListLoad($); }, 100);
  });

  //get the list count
  getListCount($);
});*/





/*================================================================================
Definition: see's if the list has more items to load
================================================================================*/
/*function setListLoad ($) {

  let $listWrapper = $('#academics-programs-and-majors .list-wrapper'),
    $button = $('#academics-programs-and-majors .btn.load'),
    maxHeight = 0;

  //if rows shown is less than the number of rows
  if (getNumRows($) < getTotalRows($)) {

    //add a more class
    $listWrapper.addClass('more');
    $button.addClass('more');

    maxHeight = getMaxHeight ($);

  } else {

    //remove more class
    $listWrapper.removeClass('more');
    $button.removeClass('more');

    maxHeight = getMaxHeight ($);
  }

  //animate the max height
  $listWrapper.animate({
    'maxHeight': maxHeight + 'px'
  }, 10, function () {

  });
}*/





/*================================================================================
Definition: get the Max Height of the Programs List
================================================================================*/
/*function getMaxHeight ($) {
  let $listWrapper = $('#academics-programs-and-majors .list-wrapper'),
    dataRow = getNumRows($),
    totalRow = getTotalRows($),
    row = dataRow,
    maxHeight = 0;

  //if the data row is greater than the total row
  if (dataRow > totalRow) {
    row = totalRow;
  }

  //calculate the max height
  for (let i=0; i<row; i++) {
    maxHeight = maxHeight + Number($listWrapper.find('.row[data-row="'+i+'"]').height()) + 15;
  }

  return maxHeight;
}*/





/*================================================================================
Definition: Get the Number of Rows Shown
================================================================================*/
/*function getNumRows ($) {

  let $listWrapper = $('#academics-programs-and-majors .list-wrapper'),
    $rows = $('#academics-programs-and-majors .list-wrapper .row'),
    rowsShown = Number($listWrapper.attr('data-rows'));

  //get the number of show rows
  let count = 0;
  $rows.each(function (key, val) {

    if (String($(val).attr('style'))!== 'display: none;'){
      count++;
    }
  });

  //if count is less than rowsShown
  if (count < rowsShown) {
    rowsShown = count;
  }

  return rowsShown;

}*/





/*================================================================================
Definition: get Total Rows to Show
================================================================================*/
/*function getTotalRows ($) {

  let $rows = $('#academics-programs-and-majors .list-wrapper .row'),
    rowTotal = $rows.length;

  //get the number of show rows
  let count = 0;
  $rows.each(function (key, val) {

    if (String($(val).attr('style')) !== 'display: none;') {
      count++;
    }
  });

  //if count is less than rowTotal
  if (count < rowTotal) {
    rowTotal = count;
  }

  return rowTotal;
}*/





/*================================================================================
Definition: Show a counter message
================================================================================*/
/*function getListCount ($, searchText) {

  let $rows = $('#academics-programs-and-majors .list-wrapper .row'),
	    $counter = $('#academics-programs-and-majors .search-container .counter');

  $count = 0;
  $rows.each(function (i, el) {

    if ($(el).css('display') === 'block') {
      $count++;
    }
  });

  if (typeof(searchText) === 'undefined' || searchText === '') {
    $counter.html($count + ' programs');
  } else {
    $counter.html($count + ' results matching &ldquo;' + searchText + '&rdquo;');
  }
}*/